export type ServiceTypeCode = {
  code: string
  name: string
}

export const serviceTypeCodes: ServiceTypeCode[] = [
  { code: '1', name: 'Medical Care' },
  { code: '2', name: 'Surgical' },
  { code: '3', name: 'Consultation' },
  { code: '4', name: 'Diagnostic X-Ray' },
  { code: '5', name: 'Diagnostic Lab' },
  { code: '6', name: 'Radiation Therapy' },
  { code: '7', name: 'Anesthesia' },
  { code: '8', name: 'Surgical Assistance' },
  { code: '9', name: 'Other Medical' },
  { code: '10', name: 'Blood Charges' },
  { code: '11', name: 'Used Durable Medical Equipment' },
  { code: '12', name: 'Durable Medical Equipment Purchase' },
  { code: '13', name: 'Ambulatory Service Center Facility' },
  { code: '14', name: 'Renal Supplies in the Home' },
  { code: '15', name: 'Alternate Method Dialysis' },
  { code: '16', name: 'Chronic Renal Disease Equipment' },
  { code: '17', name: 'Pre-Admission Testing' },
  { code: '18', name: 'Durable Medical Equipment Rental' },
  { code: '19', name: 'Pneumonia Vaccine' },
  { code: '20', name: 'Second Surgical Opinion' },
  { code: '21', name: 'Third Surgical Opinion' },
  { code: '22', name: 'Social Work' },
  { code: '23', name: 'Diagnostic Dental' },
  { code: '24', name: 'Periodontics' },
  { code: '25', name: 'Restorative' },
  { code: '26', name: 'Endodontics' },
  { code: '27', name: 'Maxillofacial Prosthetics' },
  { code: '28', name: 'Adjunctive Dental Services' },
  { code: '30', name: 'Health Benefit Plan Coverage' },
  { code: '32', name: 'Plan Waiting Period' },
  { code: '33', name: 'Chiropractic' },
  { code: '34', name: 'Chiropractic Office Visits' },
  { code: '35', name: 'Dental Care' },
  { code: '36', name: 'Dental Crowns' },
  { code: '37', name: 'Dental Accident' },
  { code: '38', name: 'Orthodontics' },
  { code: '39', name: 'Prosthodontics' },
  { code: '40', name: 'Oral Surgery' },
  { code: '41', name: 'Routine Preventive Dental' },
  { code: '42', name: 'Home Health Care' },
  { code: '43', name: 'Home Health Prescriptions' },
  { code: '44', name: 'Home Health Visits' },
  { code: '45', name: 'Hospice' },
  { code: '46', name: 'Respite Care' },
  { code: '47', name: 'Hospital' },
  { code: '48', name: 'Hospital Inpatient' },
  { code: '49', name: 'Hospital Room and Board' },
  { code: '50', name: 'Hospital Outpatient' },
  { code: '51', name: 'Hospital Emergency Accident' },
  { code: '52', name: 'Hospital Emergency Medical' },
  { code: '53', name: 'Hospital Ambulatory Surgical' },
  { code: '54', name: 'Long Term Care' },
  { code: '55', name: 'Major Medical' },
  { code: '56', name: 'Medical Transportation' },
  { code: '57', name: 'Air Transportation' },
  { code: '58', name: 'Cabulance' },
  { code: '59', name: 'Licensed Ambulance' },
  { code: '60', name: 'General Benefits' },
  { code: '61', name: 'In-vitro Fertilization' },
  { code: '62', name: 'MRI CAT Scan' },
  { code: '63', name: 'Donor Procedures' },
  { code: '64', name: 'Acupuncture' },
  { code: '65', name: 'Newborn Care' },
  { code: '66', name: 'Pathology' },
  { code: '67', name: 'Smoking Cessation' },
  { code: '68', name: 'Well Baby Care' },
  { code: '69', name: 'Maternity' },
  { code: '70', name: 'Transplants' },
  { code: '71', name: 'Audiology Exam' },
  { code: '72', name: 'Inhalation Therapy' },
  { code: '73', name: 'Diagnostic Medical' },
  { code: '74', name: 'Private Duty Nursing' },
  { code: '75', name: 'Prosthetic Device' },
  { code: '76', name: 'Dialysis' },
  { code: '77', name: 'Otological Exam' },
  { code: '78', name: 'Chemotherapy' },
  { code: '79', name: 'Allergy Testing' },
  { code: '80', name: 'Immunizations' },
  { code: '81', name: 'Routine Physical' },
  { code: '82', name: 'Family Planning' },
  { code: '83', name: 'Infertility' },
  { code: '84', name: 'Abortion' },
  { code: '85', name: 'AIDS' },
  { code: '86', name: 'Emergency Services' },
  { code: '87', name: 'Cancer' },
  { code: '88', name: 'Pharmacy' },
  { code: '89', name: 'Free Standing Prescription Drug' },
  { code: '90', name: 'Mail Order Prescription Drug' },
  { code: '91', name: 'Brand Name Prescription Drug' },
  { code: '92', name: 'Generic Prescription Drug' },
  { code: '93', name: 'Podiatry' },
  { code: '94', name: 'Podiatry Office Visits' },
  { code: '95', name: 'Podiatry Nursing Home Visits' },
  { code: '96', name: 'Professional Physician' },
  { code: '97', name: 'Anesthesiologist' },
  { code: '98', name: 'Physician Office Visit' },
  { code: '99', name: 'Physician Inpatient Visit' },
  { code: 'MH', name: 'Mental Health' },
  { code: 'PT', name: 'Physical Therapy' },
  { code: 'RT', name: 'Residential Psychiatric Treatment' },
  { code: 'UC', name: 'Urgent Care' },
]

export function getServiceTypeCodeOptions(): { value: string; label: string }[] {
  return serviceTypeCodes.map((item) => ({
    value: item.code,
    label: `${item.name} (${item.code})`,
  }))
}

export function findServiceTypeCodeName(code: string): string {
  const hit = serviceTypeCodes.find(
    (item) => item.code.toUpperCase() === code.trim().toUpperCase()
  )
  return hit?.name ?? code.trim()
}
